import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { localStorageService, IRecentActivityItem } from "src/services/local-storage.service";

import styles from "./RecentActivity.module.scss";

const typeLabel: Record<IRecentActivityItem["type"], string> = {
    event: "Event",
    course: "Course",
    club: "Club",
};

const RecentActivity: React.FC = () => {
    const [items, setItems] = useState<IRecentActivityItem[]>([]);

    useEffect(() => {
        setItems(localStorageService.getRecentActivity());
    }, []);

    if (items.length === 0) return null;

    return (
        <div className={styles.RecentActivity}>
            <div className={styles.title}>Recent Activity</div>
            <ul className={styles.list}>
                {items.map((item) => (
                    <li key={item.id} className={styles.item}>
                        <Link to={item.link} className={styles.inner}>
                            <div className={styles.portrait}>
                                {item.logo_url ? (
                                    <div
                                        className={styles.portraitImage}
                                        style={{ backgroundImage: `url('${item.logo_url}')` }}
                                    />
                                ) : (
                                    <div className={styles.portraitFallback}>
                                        {item.name.charAt(0).toUpperCase()}
                                    </div>
                                )}
                            </div>
                            <div className={styles.content}>
                                <span className={styles.name}>{item.name}</span>
                                <span className={styles.type}>{typeLabel[item.type]}</span>
                            </div>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default RecentActivity;
